import { render, staticRenderFns } from "./ShowCommandHeader.vue?vue&type=template&id=6055609a"
import script from "./ShowCommandHeader.vue?vue&type=script&lang=js"
export * from "./ShowCommandHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports